export class PermissionModel {
  constructor({ setor, grupo, funcionalidades, setorResponsavel, funcionalidadesId }) {
    this.setor = setor;
    this.grupo = grupo;
    this.funcionalidades = funcionalidades;
    this.funcionalidadesId = funcionalidadesId;
    this.setorResponsavel = setorResponsavel;
  }

  static fromJson(json) {
    return new PermissionModel({
      setor: json.setor,
      grupo: json.grupo,
      funcionalidades: json.funcionalidade,
      setorResponsavel: json.setor_responsavel,
      funcionalidadesId: json.funcionalidade_id
    });
  }
}
